import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-rich-text-element',
    templateUrl: './rich-text-element.component.html',
    styleUrls: ['./rich-text-element.component.css'],
    standalone: false
})
export class RichTextElementComponent implements OnInit {

  @Input() richtext;
  @Output() onRichTextChange = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  // app-template-editor emits the HTML string directly. TinyMCE's <editor>
  // emitted an event object and the content had to be pulled off
  // event.editor.getContent().
  showValue(html: string) {
    this.onRichTextChange.emit(html);
  }

}
